<div class="wrapper--radio" [formGroup]="formGroup">
  <div class="wrapper--radio--title">
    <nx-label [size]="field.labelSize ?? 'large'">
      {{ field.label | translate }}
    </nx-label>
  </div>
  <nx-radio-group [formControlName]="field.name" [name]="field.name">
    <div class="wrapper--radio--item">
      <nx-radio
        *ngFor="let item of field.list"
        [value]="item.value"
        [labelSize]="field.valueSize ?? 'big'"
      >
        {{ item.text | translate }}
      </nx-radio>
    </div>
  </nx-radio-group>
</div>
